// extracted by mini-css-extract-plugin
export default {"videoCard":"videocard_videoCard__0oukp","video":"videocard_video__p7yF6","play":"videocard_play__-F0XF"};